import FaultTreeVertex from '../FaultTreeVertex';
import GateVertexValue from './GateVertexValue';
import ReferenceTypes from "../../HCLTreeVertexValue/ReferenceTypes"
import HCLTreeVertex from "../../HCLTreeVertex";
import GateTypes, {GateTypeDescriptions} from "../../HCLTreeVertexValue/GateTypes";
import {mxCell, mxConstants, mxGeometry} from "mxgraph-js";

abstract class GateVertex extends FaultTreeVertex {

  protected constructor(key: string, value: GateVertexValue) {
    super(key, value, ReferenceTypes.GATES);
  }

  getMyGeometry(): mxGeometry {
    return new mxGeometry(0, 0, HCLTreeVertex.SHAPE.WIDTH, HCLTreeVertex.SHAPE.HEIGHT);
  }

  getMyStyle(): {[index: string]: any} {
    const gateType = (this.value as GateVertexValue).getFormula().getExpression();
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_ROUNDED] = 0;
    style[mxConstants.STYLE_SPACING] = 6;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(209,207,214,0.2)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(131,135,151,0.75)';
    style[mxConstants.STYLE_FILL_OPACITY] = '50';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_ELLIPSE;
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    style[mxConstants.STYLE_SPACING_BOTTOM] = HCLTreeVertex.SHAPE.GATE;
    style[mxConstants.STYLE_SHAPE] = gateType;
    return style;
  }

  getType(): string {
    const gateType = (this.value as GateVertexValue).getFormula().getExpression();
    return GateTypeDescriptions[gateType];
  }

  public onRequestConnectChildVertex(vertex: HCLTreeVertex): mxCell {
    return this.getGraph().addEdgeBetween(this, vertex);
  }
}

export default GateVertex;
